// extracted by mini-css-extract-plugin
export var clickThrough = "_yc-2";
export var fallback = "_yc-5";
export var frame = "_yc-3";
export var frameCell = "_yc-1";
export var overlay = "_yc-4";
export var wrapper = "_yc-0";